import type { AssetsAssetSchemaTypedWithId } from '@iconik-io/iconik-api/src/services/assets';

import type { SearchItemEntity } from '../redux/entities/normalized/search_item';

export const getObjectTypeFromAssetOrSearchItem = (
  object: SearchItemEntity | AssetsAssetSchemaTypedWithId | undefined,
) => {
  if (!object) {
    return undefined;
  }

  if ('object_type' in object) {
    return object.object_type;
  }
  return 'assets';
};
